import p1_img from './shose_women/p1.jpg'
import p2_img from './shose_women/p2.jpg'
import p3_img from './shose_women/p3.jpg'
import p4_img from './shose_women/p4.jpg'

let data_product = [
  {
    id: 1,
    name: "ARCH FIT - COMFY WAVE",
    category: "women",
    image: p1_img,
    new_price: 1259.0,
    old_price: 1499.0,
    descriptions: "Your feet will thank you for the supportive comfort and sporty style of the SKECHERS Arch Fit - Comfy Wave shoe. Sporty engineered knit mesh fabric upper in a lace up sporty cas",
  },
  {
    id: 2,
    name: "D'LUX FITNESS-ROAM FREE",
    category: "women",
    image: p2_img,
    new_price: 1120.0,
    old_price: 1889.0,
    descriptions: "This lace-up features a breathable mesh and synthetic upper, Skechers Air-Cooled Memory Foam insole and a well-cushioned midsole",
  },
  {
    id: 3,
    name: "D'LUX WALKER-FRESH FINESSE",
    category: "women",
    image: p3_img,
    new_price: 1599.0,
    old_price: 1999.0,
    descriptions: "D'Lux Walker - Fresh Finesse. This lace-up features an engineered mesh upper with a Skechers Air-Cooled Memory Foam insole and a cushioned platform midsole",
  },
  {
    id: 4,
    name: "ELITE SPORT PRO- RADIANT SQUA",
    category: "women",
    image: p4_img,
    new_price: 999.0,
    old_price: 1599.0,
    descriptions: "Athletic style and awesome comfort combine in Skechers Elite Sport - Radiant Squads. This lace-up features an engineered mesh upper with synthetic hotmelt detail, cushione",
  },
];

export default data_product;
